import type { ModuleRoute } from '../types';
import { SecurityPage } from './SecurityPage';
import { RequireStage } from '../../lib/session';
import { PasswordChangePage } from '../../pages/auth/PasswordChangePage';

/** Pages of this area (security settings card (password policy, SSO), password-change and Microsoft sign-in screens, support banner, personal tokens). Owned by Phase 4 task W24; only that task edits files in this folder (W32 wires it last). */
export const routes: ModuleRoute[] = [
  { path: '/admin/security', element: <SecurityPage />, permission: 'account.manage' },
  // Login step for stage `password_change`; like the other /login pages it has no shell.
  { path: '/login/password', element: <RequireStage stage="password_change"><PasswordChangePage /></RequireStage>, public: true },
];
